import { useState } from 'react';

const useSteps = ({ min = 0, max }) => {
  const [step, setStep] = useState(min);
  const isLast = step === max;
  const isFirst = step === min;

  const forward = () => {
    if (!isLast) {
      setStep(step + 1);
    }
  };
  const back = () => {
    if (!isFirst) {
      setStep(step - 1);
    }
  };

  return { step, forward, back, isFirst, isLast, setStep };
};

export default useSteps;
